<template>
  <v-container class="pa-0 " fluid>
    <v-carousel
      v-if="sizeName == 'xl' || sizeName == 'lg' || sizeName == 'md'"
      cycle
      interval="10000"
      hide-delimiters
      show-arrows-on-hover
      class="white py-0 px-0"
      light
      height="100%"
    >
      <v-carousel-item
        v-for="(banner, i) in banners"
        :key="i"
      >
        <v-sheet
          height="100%"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-img :src="url + banner.nombanner" contain  height="100%"></v-img>
          </v-row>
        </v-sheet>
      </v-carousel-item>
      <!-- <v-carousel-item
        v-for="(banner, i) in banners"
        :key="i"
        class="white"
      >
          <v-img :src="url + banner.nombanner" contain  height="100%"
          >
          </v-img>
        </v-sheet>
      </v-carousel-item> -->
    </v-carousel>

    <v-carousel
      v-else
      cycle
      width="100%"
      hide-delimiters
      show-arrows-on-hover
      class="white py-0 px-0"
      light
      height="100%"
      >
      <v-carousel-item
        v-for="(banner, i) in banners"
        :key="i"
        class="white"
      >
        <v-card height="100%">
          <v-img :src="url + banner.nombanner" contain width="100%" height="100%" ></v-img>
        </v-card>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-container>


</template>

<script>
  export default {
    data () {
      return {
        banners:[],
        url:'',
      }
    },

    mounted () {
      console.log(this.$vuetify.breakpoint.height)
    },

    created(){
      this.url = this.$http.options.root + 'fotos/'
      this.init()
    },

    methods:{
      init(){
        this.$http.get('banner.list').then(response=>{
          console.log(response.body)
          this.banners = response.body
        }).catch(error=>{console.log(error)})
      }
    },

    computed: {
      imageHeight () {
        return this.$vuetify.breakpoint.height
      },

      sizeName () {
        return this.$vuetify.breakpoint.name
      },
    },
  }
</script>